var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.loading)?_c('div',{attrs:{"id":"preloader"}},[_vm._m(0)]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"status"}},[_c('div',{staticClass:"spinner"})])
}]

export { render, staticRenderFns }